
import { getAllVehicleNumber, getChartExpense, getUserAccountList, handleKeyDown, venderDropdownApi } from '_services';
import { addPurchaseBill, addService, getGstTypeData, getItemsList, getStoreList } from '_services/workShopServices/workShopServices';
import { ButtonHeading, CityDropdownForTrip, CommonInput, CustomSelect, SkeletonInput } from 'components'
import BootstrapTable from 'components/BootstrapTable';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import { constant } from 'constants/constant';
import { UserContext } from 'context';
import { utils } from 'helper';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { AddEditVendors, AddExpenseServiceModal, AddWorkShopItemModal } from 'modals';
import AddEditStoreModel from 'modals/AddEditStoreModel';
import React, { useCallback, useState, useEffect, useMemo, useContext } from 'react'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { StorageServices } from 'utils';
import StorageService from 'utils/StorageServices';

const AddEditPurchaseBill = () => {
    useDocumentTitle("Add Purchase Bill | T360");

    const { workShopChild } = useContext(UserContext);
    const workShopChildStore = workShopChild?.find((i) => i?.label === "Store");

    const navigate = useNavigate()
    const taxOptions = [
        { label: "12%", value: 12 },
        { label: "18%", value: 18 },
    ];
    // Define columns based on is_gst_chareged
    const getColumns = (isGst) => {
        const baseColumns = [
            { header: "Items", accessor: "items" },
            { header: "Description", accessor: "description" },
            { header: "Store", accessor: "store" },
            { header: "Quantity", accessor: "quantity" },
            { header: "Rate", accessor: "rate" },
            { header: "Discount", accessor: "discount" },
        ];
        const gstColumns = [
            { header: "Tax", accessor: "tax" },
        ];
        const endColumns = [
            { header: "Amount", accessor: "amount" },
            { header: "", accessor: "remove" },
        ];
        if (isGst) {
            return [...baseColumns, ...gstColumns, ...endColumns];
        }
        return [...baseColumns, ...endColumns];
    };

    const addDays = (date, days) => {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result.toISOString().split("T")[0];
    };

    const companyId = StorageServices?.getCompanyId()
    const [showInvoice, setShowInvoice] = useState(true)
    const [loading, setLoading] = useState(false)
    const initialform = {
        company_id: companyId,
        add_invoice: showInvoice, // 0 = Off, 1= On
        vendor_id: "",
        invoice_number: "",
        invoice_date: new Date().toISOString().split("T")[0],
        due_date: addDays(new Date().toISOString().split("T")[0], 2),
        is_gst_chareged: 0, // 0 = No, 1= Yes
        items: [
            {
                item_id: {},
                description: "",
                store_id: {},
                quantity: '',
                rate: '',
                discount: '',
                tax: {},
                amount: ''
            }
        ],
        sub_total: '',
        discount: '',
        tds: '',
        adjust_amount: '',
        total_amount: '',
        payment_mode: 1, // 0 = Full, 1= Partial
        payment_type: 1,
    };

    const [form, setForm] = useState(initialform)
    const [itemsList, setItemsList] = useState([]);
    const [storeList, setStoreList] = useState([]);
    const [expenseCategoryList, setCategoryExpenseList] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [modalType, setModalType] = useState("")
    const [formErrors, setFormErrors] = useState({})
    const [gstTypeList, setGstTypeList] = useState([]);

    const [expenseTypeList, setExpenseTypeList] = useState([]);
    const [expenseAccount, setExpenseAccount] = useState([]);
    const [expenseList, setExpenseList] = useState([]);
    const [accountLoading, setAccountLoading] = useState(false);
    const [accountList, setAccountList] = useState([]);
    const [accountType, setAccountType] = useState();

    const [showOffcanvasVendor, setShowOffcanvasVendor] = useState(false);
    const [storeModelData, setStoreModelData] = useState(false);
    const [itemIndex, setItemIndex] = useState(false);

    const { masterData, mastersChild } = useContext(UserContext);
    const masterChildVendors = mastersChild?.find((i) => i?.label === "Vendors");

    useEffect(() => {
        setForm(prevItems => ({ ...prevItems, due_date: addDays(form?.invoice_date, 2) }));
    }, [form?.invoice_date])

    useEffect(() => {
        if (form.is_gst_chareged === 0) {
            setExpenseList(prevItems =>
                prevItems.map(item => {
                    const qty = Number(item.quantity) || 0;
                    const rate = Number(item.rate) || 0;
                    const discount = Number(item.discount) || 0;
                    const baseAmount = qty * rate;
                    const amountAfterDiscount = baseAmount - discount;

                    return {
                        ...item,
                        tax: {},
                        amount: amountAfterDiscount
                    };
                })
            );
        }
    }, [form.is_gst_chareged]);

    const fetchVehicle = async (search, page, limit) => {
        const res = await getAllVehicleNumber({
            company_id: companyId,
            offset: page,
            limit,
            search,
            vehicle_ownership: [1, 3]
        });
        if (res?.responseCode === 200) {
            const list = res?.data?.vehicle_list?.map((i) => ({
                ...i,
                name: `${i?.vehicle_no}`,
                ownershipStatus: i?.vehicle_ownership,
            }));
            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            return { items: [], total: 0 };
        }
    };

    const fetchVendor = useCallback(async (search, page, limit) => {
        try {
            const response = await venderDropdownApi({
                company_id: StorageService.getCompanyId(),
                offset: page,
                limit,
                search,
            });

            if (response?.responseCode === 200) {
                const vendors = response.data.vendor_list.map(vendor => ({
                    ...vendor,
                    label: vendor.name,
                    value: vendor._id
                }));

                return {
                    items: vendors,
                    total: response.data.total_record || vendors.length,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, []);

    const getItemHandler = async () => {
        try {
            const res = await getItemsList({
                company_id: StorageService.getCompanyId(),
                limit: 100,
                offset: 1,
                status: 1
            });

            if (res?.responseCode === 200) {
                const details = res?.data?.itemData?.map((item) => {
                    return {
                        label: item?.name,
                        value: item?._id,
                    };
                });
                setItemsList(details);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const getStoreHandler = async () => {
        try {
            const res = await getStoreList({
                company_id: StorageService.getCompanyId(),
                limit: 100,
                offset: 1,
                status: 1
            });

            if (res?.responseCode === 200) {
                const details = res?.data?.storeData?.map((item) => {
                    return {
                        label: item?.name,
                        value: item?._id,
                    };
                });
                setStoreList(details);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const getGstTypeList = async () => {
        try {
            let object = { company_id: StorageService.getCompanyId() }
            const res = await getGstTypeData();
            if (res?.responseCode === 200) {
                let array = res?.data?.map((el) => {
                    return {
                        label: `${el?.perc} %`,
                        perc: el?.perc,
                        value: el?.id,
                    }
                })
                setGstTypeList(array);
            } else {
                toast.error(res?.responseMessage);
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        getGstTypeList();
        getItemHandler();
        getStoreHandler();
        getMasterFreight();
    }, [])

    const handleAddExpense = (e) => {
        e.preventDefault();
        // setModalType(true);
        setShowModal(true);
    };

    const handleExpenseSubmit = (expenseData) => {
        setExpenseList((s) => ([...s, expenseData]));
        toast.success(`Item added successfully`);
        // setShowModal(false)
    };

    const handleRemoveExpense = (id) => {
        setExpenseList(expenseList.filter(item => item._id !== id));
    };

    const handleExpenseChange = (id, field, value) => {
        // Update the data
        setExpenseList(prev =>
            prev.map(item => {
                if (item._id === id) {
                    const updatedItem = { ...item, [field]: value };

                    // Use updatedItem values instead of item values
                    const qty = Number(updatedItem.quantity) || 0;
                    const rate = Number(updatedItem.rate) || 0;
                    let discount = Number(updatedItem.discount) || 0;
                    const tax = Number(updatedItem.tax?.perc) || 0;

                    let totalAmount = (qty * rate);

                    // ✅ Validate: Discount cannot exceed base amount
                    if (discount > totalAmount) {
                        discount = totalAmount;
                        updatedItem.discount = totalAmount; // Cap the discount
                    }

                    if (form.is_gst_chareged === 1 && tax > 0) {
                        let updateValue = (totalAmount + (totalAmount * tax / 100));
                        totalAmount = updateValue - discount;
                    } else {
                        totalAmount = totalAmount - discount;
                    }
                    updatedItem.amount = totalAmount;
                    return updatedItem;
                }
                return item;
            })
        );

        // Clear specific field error when user starts typing
        setFormErrors(prev => {
            const newErrors = { ...prev };
            if (newErrors[`item_${id}`]?.[field]) {
                delete newErrors[`item_${id}`][field];
                // If no more errors for this item, remove the item key
                if (Object.keys(newErrors[`item_${id}`]).length === 0) {
                    delete newErrors[`item_${id}`];
                }
            }
            return newErrors;
        });
    };

    const calculateTotals = useCallback(() => {
        const subTotal = utils.getTotalAmount(expenseList, 'amount');
        let discountOnBill = Number(form.discount) || 0;
        let tds = Number(form.tds) || 0;
        const adjust_amount = Number(form.adjust_amount) || 0;

        // const totalAmount = subTotal - discountOnBill - tds + adjust_amount;

        // setForm(prev => ({
        //     ...prev,
        //     sub_total: subTotal.toFixed(2),
        //     total_amount: totalAmount.toFixed(2)
        // }));

        // ✅ Validate: Discount cannot exceed subtotal
        if (discountOnBill > subTotal) {
            discountOnBill = subTotal;
            setForm(prev => ({ ...prev, discount: subTotal.toFixed(2) }));
        }

        // ✅ Validate: TDS cannot exceed (subtotal - discount)
        const amountAfterDiscount = subTotal - discountOnBill;
        if (tds > amountAfterDiscount) {
            tds = amountAfterDiscount;
            setForm(prev => ({ ...prev, tds: amountAfterDiscount.toFixed(2) }));
        }

        // Final Net Total
        const totalAmount = subTotal - discountOnBill - tds + adjust_amount;

        setForm(prev => ({
            ...prev,
            sub_total: subTotal.toFixed(2),
            total_amount: Math.max(0, totalAmount).toFixed(2) // ✅ Prevent negative total
        }));
    }, [expenseList, form.discount, form.tds, form.adjust_amount]);

    const handleInvoiceToggle = (e) => {
        const checked = e.target.checked;
        setShowInvoice(checked);

        if (!checked) {
            setForm((prev) => ({
                ...prev,
                vendor_id: "",
                invoice_number: "",
                invoice_date: new Date().toISOString().split("T")[0],
                due_date: addDays(new Date().toISOString().split("T")[0], 2),
                is_gst_chareged: 0,
                add_invoice: false
            }))
            // Clear invoice related errors
            setFormErrors({})
        } else {
            setForm((prev) => ({
                ...prev,
                add_invoice: true
            }))
        }
    }

    const handleInputChange = (name, value) => {
        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
        // Clear error when field is updated
        if (formErrors[name]) {
            setFormErrors(prev => ({ ...prev, [name]: "" }))
        }
    }

    const validateForm = () => {
        const errors = {};

        // Invoice validations
        if (showInvoice && form.add_invoice) {
            if (!form.vendor_id) {
                errors.vendor_id = "Please select a vendor";
            }

            if (!form.invoice_number || form.invoice_number.trim() === "") {
                errors.invoice_number = "Please enter invoice number";
            }

            if (!form.invoice_date) {
                errors.invoice_date = "Please select invoice date";
            }

            if (!form.due_date) {
                errors.due_date = "Please select due date";
            }

            // Validate due date is at least 2 days after invoice date
            if (form.invoice_date && form.due_date) {
                const invoiceDate = new Date(form.invoice_date);
                const dueDate = new Date(form.due_date);

                // Calculate difference in days
                const diffTime = dueDate - invoiceDate;
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                if (diffDays < 2) {
                    errors.due_date = "Due date must be at least 2 days after invoice date";
                }
            }
        }

        // Expense list validation
        if (!expenseList || expenseList.length === 0) {
            errors.expense_list = "Please add at least one item";
            toast.error("Please add at least one item");
        } else {
            // Validate each item
            let hasExpenseErrors = false;

            expenseList.forEach((item, index) => {
                const itemErrors = {};

                // Validate Category
                if (!item.store_id || !item.store_id.value) {
                    itemErrors.store_id = "Store is required";
                    hasExpenseErrors = true;
                }

                // Validate Quantity
                if (!item.quantity || item.quantity <= 0) {
                    itemErrors.quantity = "Quantity must be greater than 0";
                    hasExpenseErrors = true;
                }

                // Validate Rate
                if (item.rate === undefined || item.rate === null || item.rate === "") {
                    itemErrors.rate = "Rate is required";
                    hasExpenseErrors = true;
                } else if (Number(item.rate) < 0) {
                    itemErrors.rate = "Rate cannot be negative";
                    hasExpenseErrors = true;
                }

                // Validate Tax (required only when GST is enabled)
                if (form.is_gst_chareged === 1) {
                    if (!item.tax || !item.tax.value) {
                        itemErrors.tax = "Tax is required";
                        hasExpenseErrors = true;
                    }
                }

                // Validate Amount
                // if (!item.amount || item.amount <= 0) {
                //     itemErrors.amount = "Amount must be greater than 0";
                //     hasExpenseErrors = true;
                // }

                // Store errors for this item if any
                if (Object.keys(itemErrors).length > 0) {
                    errors[`item_${item._id}`] = itemErrors;
                }
            });

            // Show toast for item errors
            if (hasExpenseErrors) {
                toast.error("Please fill all required fields in items");
            }
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // Handle form submission
    const handleSubmit = async () => {
        if (validateForm()) {
            const formattedItems = expenseList.map((element) => {
                return {
                    ...element,
                    item_id: element?.item_id?.value,
                    store_id: element?.store_id?.value,
                    tax: Number(element.tax.value) || 0,
                    description: element.description || "",
                    amount: parseFloat(Number(element.amount).toFixed(2))
                }
            });

            // Prepare payload matching API structure
            const payload = {
                company_id: form?.company_id,
                add_invoice: form?.add_invoice ? 1 : 0, // 0 = Off, 1= On
                vendor_id: (form.add_invoice && form.vendor_id._id) ? form.vendor_id._id : "",
                invoice_number: form.add_invoice ? form.invoice_number : "",
                invoice_date: form.add_invoice ? utils.getTodayDate(form.invoice_date) : "",
                due_date: form.add_invoice ? utils.getTodayDate(form.due_date) : "",
                is_gst_chareged: Number(form.is_gst_chareged),
                items: formattedItems,
                sub_total: parseFloat(form.sub_total),
                discount: parseFloat(Number(form.discount).toFixed(2)),
                tds: parseFloat(Number(form.tds).toFixed(2)),
                adjust_amount: parseFloat(Number(form.adjust_amount).toFixed(2)),
                total_amount: parseFloat(form.total_amount),
                payment_mode: form?.payment_mode, // 0 = Full, 1= Partial
                payment_type: form?.payment_type,
            }

            try {
                setLoading(true)
                const res = await addPurchaseBill(payload)
                if (res?.responseCode === 200) {
                    toast.success(res?.responseMessage)
                    navigate("/PurchaseBill")
                }
            } catch (error) {
                setLoading(false)
            } finally {
                setLoading(false)
            }

        } else {

        }
    };

    const updateCallBackData = (data) => {
        setExpenseList((prev) =>
            prev.map((item, indx) => {
                if (item?._id === itemIndex?.data?._id && +itemIndex?.index === +indx) {
                    return {
                        ...item,
                        store_id: { label: data?.name, value: data?._id }
                    };
                }
                return item;
            })
        );
        setItemIndex({});
        getStoreHandler();
    }

    let storeModelProps = {
        isOpen: storeModelData,
        closeModal: (e) => setStoreModelData(false),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: storeModelData?.isDetails ? "View Store" : (storeModelData?._id ? 'Update Store' : 'Add Store'),
        submitTitle: storeModelData?.isDetails ? "View Store" : (storeModelData?._id ? 'Update Store' : 'Add Store'),
        footerPart: storeModelData?.isDetails ? true : false,
        hideFooterSumbmitBtn: storeModelData?.isDetails ? true : false,
        hideCompletelyFoolter: storeModelData?.isDetails ? true : false,
        getDataCallBack: (data) => updateCallBackData(data),
    }

    const fetchItem = async (search, page, limit) => {
        const res = await getItemsList({
            company_id: companyId,
            offset: page,
            limit,
            search,
            status: 1
        });
        if (res?.responseCode === 200) {
            const list = res?.data?.itemData?.map((i) => ({
                ...i,
                label: i?.name,
                value: i?._id,
            }));
            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            return { items: [], total: 0 };
        }
    };

    const fetchStore = async (search, page, limit) => {
        const res = await getStoreList({
            company_id: companyId,
            offset: page,
            limit,
            search,
            status: 1
        });
        if (res?.responseCode === 200) {
            const list = res?.data?.storeData?.map((i) => ({
                ...i,
                label: i?.name,
                value: i?._id,
            }));
            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            return { items: [], total: 0 };
        }
    };

    const rowListData = (data) => {
        return data?.map((item, itemIndex) => {
            const baseRow = {
                items: (
                    <SingleSelectDropdownInfinite
                        label="Item"
                        fetchData={fetchItem}
                        selectedItem={item.item_id || null}
                        onChange={(data) => handleExpenseChange(item._id, "item_id", data)}
                        loadOnOpen={true}
                        // error={formErrors.category}
                        // errorMessage={formErrors.category}
                        singleDropClass="__minHdrop"
                    />
                    // <CustomSelect
                    //     label="Item"
                    //     placeholder="Item"
                    //     options={itemsList}
                    //     value={item.item_id || null}
                    //     onSelect={(data) => handleExpenseChange(item._id, "item_id", data)}
                    // />
                ),
                description: (
                    <CommonInput
                        type="text"
                        className="form-control"
                        value={item.description}
                        onChange={(e) => handleExpenseChange(item._id, 'description', e.target.value)}
                        placeholder="Item Description"
                        style={{ minWidth: '300px', width: "100%" }}
                        error={formErrors[`item_${item._id}`]?.description}
                        focus={formErrors[`item_${item._id}`]?.description}
                        errorShow={false}
                        maxLength="40"
                        onInput={utils.maxLengthCheck}
                    />
                ),
                store: (
                    <SingleSelectDropdownInfinite
                        label="Store"
                        fetchData={fetchStore}
                        selectedItem={item.store_id || null}
                        onChange={(data) => handleExpenseChange(item._id, "store_id", data)}
                        loadOnOpen={true}
                        error={formErrors[`item_${item._id}`]?.store_id}
                        // errorMessage={formErrors[`item_${item._id}`]?.store_id}
                        singleDropClass="__minHdrop"
                        isAddButton={workShopChildStore?.create === 1 ? true : false}
                        addButtonAction={(e) => { setStoreModelData(true); setItemIndex({ data: item, index: itemIndex }) }}
                    />
                    // <CustomSelect
                    //     label="Store"
                    //     placeholder="Store"
                    //     options={storeList}
                    //     value={item.store_id || null}
                    //     onSelect={(data) => handleExpenseChange(item._id, "store_id", data)}
                    //     error={formErrors[`item_${item._id}`]?.store_id}
                    //     focus={formErrors[`item_${item._id}`]?.store_id}
                    //     errorShow={false}
                    //     isAddButton={true}
                    //     addButtonAction={(e) => { setStoreModelData(true); setItemIndex({ data: item, index: itemIndex }) }}
                    // />
                ),
                quantity: (
                    <div style={{ minWidth: '120px' }}>
                        <CommonInput
                            type="number"
                            className="form-control"
                            value={item?.quantity}
                            onChange={(e) => handleExpenseChange(item._id, 'quantity', e.target.value)}
                            placeholder="Qty"
                            min="0"
                            style={{ minWidth: '80px', width: 100 }}
                            error={formErrors[`item_${item._id}`]?.quantity}
                            focus={formErrors[`item_${item._id}`]?.quantity}
                            errorShow={false}
                            onKeyDown={handleKeyDown}
                            maxLength="6"
                            onInput={utils.maxLengthCheck}
                        />
                    </div>
                ),
                rate: (
                    <div style={{ minWidth: '120px' }}>
                        <CommonInput
                            type="number"
                            className="form-control"
                            value={item.rate}
                            onChange={(e) => handleExpenseChange(item._id, 'rate', e.target.value)}
                            placeholder="Rate"
                            min="0"
                            step="0.01"
                            error={formErrors[`item_${item._id}`]?.rate}
                            focus={formErrors[`item_${item._id}`]?.rate}
                            errorShow={false}
                            style={{ minWidth: '80px', width: 100 }}
                            onKeyDown={handleKeyDown}
                            maxLength="6"
                            onInput={utils.maxLengthCheck}
                        />
                    </div>
                ),
                discount: (
                    <div style={{ minWidth: '120px' }}>
                        <CommonInput
                            type="number"
                            className="form-control"
                            value={item.discount}
                            onChange={(e) => handleExpenseChange(item._id, 'discount', e.target.value)}
                            placeholder="Discount"
                            min="0"
                            step="0.01"
                            error={formErrors[`item_${item._id}`]?.discount}
                            focus={formErrors[`item_${item._id}`]?.discount}
                            errorShow={false}
                            style={{ minWidth: '80px', width: 100 }}
                            onKeyDown={handleKeyDown}
                            maxLength="6"
                            onInput={utils.maxLengthCheck}
                        />
                    </div>
                ),
            };

            // Add HSN and Tax columns only if is_gst_chareged is 1
            if (form.is_gst_chareged === 1) {
                baseRow.tax = (
                    <CustomSelect
                        label="Tax"
                        placeholder="Select Tax"
                        options={gstTypeList}
                        value={item.tax || null}
                        onSelect={(data) => handleExpenseChange(item._id, "tax", data)}
                        error={formErrors[`item_${item._id}`]?.tax}
                        focus={formErrors[`item_${item._id}`]?.tax}
                        errorShow={false}

                    />
                );
            }

            // Add amount and remove columns
            baseRow.amount = (
                <CommonInput
                    type="text"
                    className="form-control"
                    value={`₹ ${Number(item.amount).toFixed(2)}`}
                    placeholder="0.00"
                    disabled
                    style={{ minWidth: '80px', width: 100 }}
                />
            );

            baseRow.remove = (
                <button
                    className="btn btn-sm"
                    onClick={() => handleRemoveExpense(item._id)}
                    style={{ padding: '4px 4px', background: "#FFE8E8", display: "flex", alignItems: "center", justifyContent: "center" }}
                >
                    <div style={{ width: "20px", borderRadius: "50%", background: "#D62727", color: "#ffff" }}>-</div>
                </button>
            );

            return baseRow;
        });
    };

    const expenseProps = {
        headerPart: false,
        modalMainClass: "_lgModal", // "_xxlModal",
        modalTitle: `Add Items`,
        submitTitle: `Add Items`,
        isOpen: showModal,
        closeModal: () => setShowModal(false),
        onSubmitExpense: handleExpenseSubmit,
        expenseType: modalType,
        partService: true,
        is_gst_chareged: form?.is_gst_chareged,
        expenseCategoryList: expenseCategoryList,
        expenseList: expenseList
    }

    useEffect(() => {
        calculateTotals();
    }, [calculateTotals]);

    const handleOnChange = async (name, value) => {
        const stateObj = {
            ...form,
            [name]: value,
        };
        setForm(stateObj);

        // if (!!formError) {
        //     const validationResult = await utils.checkFormError(
        //         { ...stateObj },
        //         errorSchema.createPaymentInvoiceDetailsSchema
        //     );
        //     if (validationResult === true) {
        //         setFormError("");
        //     } else {
        //         setFormError(validationResult);
        //     }
        // }
    };

    const getMasterFreight = async () => {
        try {
            const details = masterData?.account_category
                ?.sub_category?.map((item) => {
                    return {
                        label: item?.name,
                        value: item?.id,
                        category_id: masterData?.account_category?.id,
                    };
                });

            const detailsAccount = masterData?.account_category?.sub_category
                ?.filter((k) => (k?.id != 15))?.filter((k) => (k?.id != 26))
                ?.map((item) => {
                    return {
                        label: item?.name,
                        value: item?.id,
                        category_id: masterData?.account_category?.id,
                    };
                });
            const order = ["Bank", "Cash", "Other"];
            const sortedData = detailsAccount.sort(
                (a, b) => order.indexOf(a.name) - order.indexOf(b.name)
            );

            if (sortedData && details) {
                setForm({
                    ...form,
                    account_category: sortedData[0]?.category_id,
                    account_sub_category: sortedData[0]?.value,
                });

                setExpenseTypeList(details);
                setExpenseAccount(sortedData);
            }
        } catch { }
    };

    const getAccountListHandler = async () => {
        setAccountLoading(true);
        try {
            const res = await getUserAccountList({
                company_id: StorageService?.getCompanyId(),
                category_id: parseInt(form?.account_category),
                sub_category_id: parseInt(form?.account_sub_category),
            });

            if (res?.responseCode === 200) {
                setAccountLoading(false);
                const details = res?.data?.account_list?.map((item) => {
                    return {
                        ...item,
                        label: item?.name,
                        value: item?._id,
                    };
                });
                setAccountList(details);
                handleOnChange("account_id", details[0]?.value);
            } else {
                setAccountLoading(false);
                setAccountList([]);
            }
        } catch (error) {
            setAccountList([]);
        }
    };

    useEffect(() => {
        if (
            (form?.account_sub_category && form?.account_category,
                expenseAccount.length)
        ) {
            if (form?.account_id == "") {
                getAccountListHandler();
            }
        }
    }, [
        form?.account_sub_category,
        form?.account_category,
        expenseAccount,
        form?.account_id,
    ]);

    useEffect(() => {
        if (expenseList?.length === 0) {
            setForm((s) => ({
                ...s,
                sub_total: '',
                discount: '',
                tds: '',
                adjust_amount: '',
                total_amount: ''
            }))
        }
    }, [expenseList])

    const addVehicleHandleVendor = (data) => {
        setShowOffcanvasVendor(true);
    };

    const callBackVendor = async (data) => {
        setForm((pre) => ({ ...pre, vendor_id: { ...data, label: data?.name, value: data?._id } }));
    }

    return (
        <>
            <div className='__addService_ws_main'>
                <ButtonHeading title="Add Purchase Bill" />
                <div className='__addSer_mid_part'>
                    <div className='__adS_main_fx mt-3'>
                        <div className='singleDiv'>
                            <div className='__addInvoice_switch'>
                                <h6>Add Invoice</h6>

                                <div className="_anvSwitcherNew form-check form-switch" >
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="actStatus"
                                        checked={showInvoice}
                                        autoComplete="off"
                                        onChange={handleInvoiceToggle}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Conditionally render invoice fields */}
                        {showInvoice && (
                            <>
                                <div className='halfDiv'>
                                    <CityDropdownForTrip
                                        label="Vendor"
                                        placeholder="Select Vendor"
                                        fetchData={fetchVendor}
                                        pageSize={20}
                                        onChange={(data) => {
                                            handleInputChange("vendor_id", data);
                                        }}
                                        selectedItem={form.vendor_id ? form?.vendor_id : null}
                                        error={formErrors.vendor_id}
                                        errorMessage={formErrors.vendor_id}
                                        isAddButton={masterChildVendors?.create === 1 ? true : false}
                                        addButtonAction={(e) => addVehicleHandleVendor(e)}
                                    />

                                </div>

                                <div className='halfDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Invoice Number"
                                        label="Invoice Number"
                                        name='invoice_number'
                                        value={form?.invoice_number}
                                        onKeyDown={handleKeyDown}
                                        onChange={(e) => handleInputChange('invoice_number', e.target.value)}
                                        maxLength={10}
                                        error={formErrors.invoice_number}
                                    />
                                </div>

                                <div className='halfDiv'>
                                    <DatePickerComponent
                                        label="Invoice Date"
                                        name="invoice_date"
                                        showTimeSelect={false}
                                        defaultTimeFix={false}
                                        max={new Date()}
                                        startDate={form?.invoice_date}
                                        onChange={(data) => handleInputChange('invoice_date', data)}
                                        error={!!(typeof formErrors === "object") ? formErrors.invoice_date : ""}
                                    />
                                </div>

                                <div className='halfDiv'>
                                    <DatePickerComponent
                                        label="Due Date"
                                        name="due_date"
                                        min={form?.invoice_date}
                                        showTimeSelect={false}
                                        defaultTimeFix={false}
                                        startDate={form?.due_date}
                                        onChange={(data) => handleInputChange('due_date', data)}
                                        error={!!(typeof formErrors === "object") ? formErrors.due_date : ""}
                                    />
                                </div>

                                <div className='checkBx_lv mt-0 p-0' style={{ width: '100%' }}>
                                    {
                                        constant.GstAddRadio?.map((el, ind) => {
                                            return (
                                                <React.Fragment key={ind}>
                                                    <div className='_dualCheckr_bx' style={{ maxWidth: '140px', width: '100%' }}>
                                                        <input
                                                            style={{ marginTop: '2px' }}
                                                            className="form-check-input"
                                                            id={+ind + "is_gst_chareged" + el?.value}
                                                            type="radio"
                                                            name="is_gst_chareged"
                                                            checked={form?.is_gst_chareged === el?.value}
                                                            value={el?.value}
                                                            onChange={(e) => handleInputChange('is_gst_chareged', el?.value)}
                                                        />
                                                        <label style={{ fontSize: '14px' }} htmlFor={+ind + "is_gst_chareged" + el.value} className="form-check-label" >
                                                            {el.label}
                                                        </label>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </div>
                            </>
                        )}
                    </div>

                    <BootstrapTable
                        tableClass={expenseList.length > 0 ? "__serviceTable_bx" : "__serviceTable_bx __serviceTableEmpty_bx"}
                        columns={getColumns(form.is_gst_chareged === 1)}
                        colSpanTb={form.is_gst_chareged === 1 ? 8 : 6}
                        data={rowListData(expenseList)}
                    />

                    <div className='__subsMain_bx'>
                        <div className='__subsLeft_bx'>
                            <button
                                className='__adTab_servBtn anime-btn'
                                onClick={(e) => handleAddExpense(e)}
                            >
                                + Add Item
                            </button>
                        </div>

                        <div className='__subsRight_bx _cy_margin'>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Sub Total</td>
                                        <td><div className='__InpMss_bx'></div></td>
                                        <td> ₹ {form.sub_total}</td>
                                    </tr>

                                    <tr>
                                        <td>Discount on Bill</td>
                                        <td>
                                            <div className='__InpMss_bx'>
                                                <input
                                                    type="number"
                                                    placeholder='0.00'
                                                    name="discount"
                                                    value={form.discount}
                                                    onChange={({ target: { name, value } }) => {
                                                        // Remove leading zeros (except for "0" or "0.")
                                                        if (/^0[0-9]/.test(value)) {
                                                            value = value.replace(/^0+/, '');
                                                        }

                                                        // Allow empty value
                                                        if (value === "") {
                                                            handleInputChange("discount", value);
                                                            return;
                                                        }

                                                        // Allow "0" for decimals
                                                        if (value === "0") {
                                                            handleInputChange("discount", value);
                                                            return;
                                                        }

                                                        // ✅ FIX 1: Limit to 6 digits before decimal
                                                        // ✅ FIX 2: Limit to 2 digits after decimal
                                                        const regex = /^\d{0,6}(\.\d{0,2})?$/;

                                                        if (regex.test(value)) {
                                                            handleInputChange('discount', value);
                                                        }
                                                    }}
                                                    // onChange={(e) => handleInputChange('discount', e.target.value)}
                                                    // maxLength="6"
                                                    // onInput={utils.maxLengthCheck}
                                                    min="0"
                                                    step="0.01"
                                                    onKeyDown={handleKeyDown}
                                                    onPaste={(e) => {
                                                        // Prevent pasting invalid values
                                                        e.preventDefault();
                                                        const pastedText = e.clipboardData.getData('text');
                                                        const regex = /^\d{0,6}(\.\d{0,2})?$/;
                                                        if (regex.test(pastedText)) {
                                                            handleInputChange('discount', pastedText);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                        <td> - ₹ {Number(form.discount).toFixed(2)}</td>
                                    </tr>

                                    <tr>
                                        <td>TDS</td>
                                        <td>
                                            <div className='__InpMss_bx'>
                                                {/* <input
                                                    type="number"
                                                    placeholder='0.00'
                                                    value={form.tds}
                                                    onChange={(e) => handleInputChange('tds', e.target.value)}
                                                    min="0"
                                                    step="0.01"
                                                    onKeyDown={handleKeyDown}
                                                    maxLength="6"
                                                    onInput={utils.maxLengthCheck}
                                                /> */}
                                                <input
                                                    type="number"
                                                    placeholder='0.00'
                                                    value={form.tds}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const regex = /^\d{0,6}(\.\d{0,2})?$/;
                                                        if (value === "" || regex.test(value)) {
                                                            handleInputChange('tds', value);
                                                        }
                                                    }}
                                                    min="0"
                                                    step="0.01"
                                                    onKeyDown={handleKeyDown}
                                                    onPaste={(e) => {
                                                        e.preventDefault();
                                                        const pastedText = e.clipboardData.getData('text');
                                                        const regex = /^\d{0,6}(\.\d{0,2})?$/;
                                                        if (regex.test(pastedText)) {
                                                            handleInputChange('tds', pastedText);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                        <td> - ₹ {Number(form.tds).toFixed(2)}</td>
                                    </tr>

                                    <tr>
                                        <td>Adjustment</td>
                                        <td>
                                            <div className='__InpMss_bx'>
                                                {/* <input
                                                type="number"
                                                placeholder='0.00'
                                                value={form.adjust_amount}
                                                onChange={(e) => handleInputChange('adjust_amount', e.target.value)}
                                                step="0.01"
                                                onKeyDown={utils.handleKeyDown}
                                            /> */}
                                                <input
                                                    type="text"
                                                    placeholder="0.00"
                                                    value={form.adjust_amount}
                                                    onChange={(e) => handleInputChange('adjust_amount', e.target.value)}
                                                    onKeyDown={utils.handleKeyDown}
                                                    maxLength="6"
                                                    onInput={utils.maxLengthCheck}
                                                />
                                            </div>
                                        </td>
                                        <td> ₹ {form.adjust_amount ? Number(form.adjust_amount).toFixed(2) : '0.00'}</td>
                                    </tr>
                                </tbody>

                                <tfoot>
                                    <tr>
                                        <td><strong>Total</strong></td>
                                        <td></td>
                                        <td><strong> ₹ {form.total_amount}</strong></td>
                                    </tr>
                                </tfoot>
                            </table>
                            <div className="_lrCl_offCavBody">
                                <div className="singleDiv">
                                    <div className="_payMode_hed">
                                        <h4> Payment Mode </h4>

                                        <div className='checkBx_lv p-0 mt-0' style={{ width: '100%' }}>
                                            {
                                                constant.isPaymentKey?.map((el, ind) => {
                                                    return (
                                                        <React.Fragment key={ind}>
                                                            <div className='_dualCheckr_bx mt-2' style={{ maxWidth: '140px', width: '100%' }}>
                                                                <input
                                                                    style={{ marginTop: '2px' }}
                                                                    className="form-check-input"
                                                                    id={+ind + "payment_mode" + el?.value}
                                                                    type="radio"
                                                                    name="payment_mode"
                                                                    checked={form?.payment_mode === el?.value}
                                                                    value={el?.value}
                                                                    onChange={(e) => handleInputChange('payment_mode', el?.value)}
                                                                />
                                                                <label style={{ fontSize: '14px' }} htmlFor={+ind + "payment_mode" + el.value} className="form-check-label" >
                                                                    {el.label}
                                                                </label>
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                })
                                            }
                                        </div>

                                        {expenseAccount.map((i, index) => (
                                            <React.Fragment key={i + '' + index}>
                                                <button
                                                    className={`_baseSpan mt-2 ${i?.value == form?.account_sub_category
                                                        ? ""
                                                        : "_bspDisable"
                                                        }`}
                                                    disabled={accountLoading}
                                                    name="account_sub_category"
                                                    value={i.value}
                                                    onClick={({ target: { name, value } }) => {
                                                        handleOnChange(name, value);
                                                        setAccountType(value);
                                                    }}
                                                >
                                                    {i.label}
                                                </button>
                                            </React.Fragment>
                                        ))}
                                        {/* <button className="_baseSpan _bspDisable" >Balance</button> */}
                                    </div>
                                </div>

                                {/* {form?.account_sub_category != 11 && (
                                <>
                                    {!accountLoading ? (
                                        <div className="singleDiv mt-2">
                                            <CustomSelect
                                                label="Select Account"
                                                name="account_id"
                                                onSelect={(data) => {
                                                    handleOnChange("account_id", data.value);
                                                }}
                                                value={
                                                    form?.account_id
                                                        ? accountList?.find(
                                                            (i) => i.value == form?.account_id
                                                        )
                                                        : { label: "", value: "" }
                                                }
                                                options={accountList}
                                            // focus={!!formError?.account_id}
                                            // error={formError.account_id}
                                            />
                                        </div>
                                    ) : (
                                        <SkeletonInput isLoading={accountLoading} />
                                    )}
                                </>
                            )} */}
                            </div>
                        </div>
                    </div>

                </div>

                <div className='bottomFix chaliBtnBx'>
                    <button
                        className="_addComm_btn anime-btn"
                        type="button"
                        style={{ maxWidth: '110px', width: '100%' }}
                        disabled={loading}
                        onClick={handleSubmit}

                    >
                        {loading ? "Saving.." : "Save"}
                    </button>
                    <button
                        className="_cancel_btn anime-btn"
                        type="button"
                        style={{ maxWidth: '110px', width: '100%' }}
                        disabled={loading}
                        onClick={() => navigate("/PurchaseBill")}
                    >
                        Cancel
                    </button>
                </div>

                {showModal && <AddWorkShopItemModal {...expenseProps} />}
            </div>

            {/* Vender modal */}
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasVendor ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showOffcanvasVendor ? 'visible' : 'hidden' }}
            >
                {showOffcanvasVendor &&
                    <AddEditVendors
                        isOpen={showOffcanvasVendor}
                        onClose={(e) => setShowOffcanvasVendor(false)}
                        callBackVendor={callBackVendor}
                        hideAddNewOption={false}
                    />
                }
            </div>
            <div className={showOffcanvasVendor ? 'offBack_drop' : ''}></div>

            {
                storeModelData
                && (
                    <AddEditStoreModel {...storeModelProps} />
                )
            }
        </>
    )
}

export default AddEditPurchaseBill